var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "start"
  }, [_c('send-sample-dialog', {
    attrs: {
      "samples": _vm.EXAMPLES
    }
  }), _c('start-header', {
    attrs: {
      "media": {
        id: 'e0b050cc-8095-464d-a309-d9da2e8fcdd8',
        alt: 'Holiday card example',
        video: true
      },
      "bg": {
        src: 'https://cdn.ellacard.com/page_backgrounds/Festive Holiday Baking.jpg',
        color: '#926E4A'
      },
      "to": {
        name: 'catalog-category',
        params: {
          category: 'holiday-cards'
        },
        hash: '#search'
      }
    },
    scopedSlots: _vm._u([{
      key: "h1",
      fn: function () {
        return [_vm._v("Send custom holiday cards and invitations in style")];
      },
      proxy: true
    }, {
      key: "h2",
      fn: function () {
        return [_vm._v("Make your family's annual holiday card unforgettable with custom pictures and videos on unlimited pages")];
      },
      proxy: true
    }])
  }), _c('start-layer', {
    attrs: {
      "clip-waves-class": "light-gradient",
      "offset": .75
    }
  }, [_c('div', {
    staticClass: "actions"
  }, [_c('v-btn', {
    staticClass: "btn-pop",
    attrs: {
      "x-large": "",
      "rounded": "",
      "dark": "",
      "color": "ec-blue",
      "to": {
        name: 'catalog-category',
        params: {
          category: 'holiday-cards'
        },
        hash: '#search'
      }
    }
  }, [_vm._v("Start a holiday card "), _c('v-icon', {
    staticClass: "mr-n1",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1), _c('v-btn', {
    staticClass: "btn-pop",
    attrs: {
      "x-large": "",
      "rounded": "",
      "dark": "",
      "color": "pink",
      "to": {
        hash: '#demo-family'
      }
    }
  }, [_vm._v("Try demo…")])], 1), _c('div', {
    staticClass: "grid-alternate"
  }, [_c('web-media', {
    staticClass: "hover-pop rounded white",
    attrs: {
      "aspect-ratio": "16 / 9",
      "id": "b26481aa-55dd-41a4-8286-aeb72a63801e",
      "alt": "Customizing a holiday card",
      "is-video": ""
    }
  }), _c('div', [_c('h4', {
    staticClass: "mb-3"
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiPencil)
    }
  }), _vm._v(" Customize everything")], 1), _c('div', [_vm._v(" Use our design tools to add your own pages with your own flare, complete with confetti, music, and backgrounds. ")])]), _c('web-media', {
    staticClass: "hover-pop rounded white",
    attrs: {
      "aspect-ratio": "16 / 9",
      "id": "6a2c961b-310a-43cd-9192-f460338b6b7e",
      "alt": "Adding photos and videos to a holiday card",
      "is-video": ""
    }
  }), _c('div', [_c('h4', {
    staticClass: "mb-3"
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiImageMultiple)
    }
  }), _vm._v(" Photos and videos")], 1), _c('div', [_vm._v(" Show off your photos and videos from the past year, or use our video maker to create your own holiday-themed video, right in your browser. ")])]), _c('web-media', {
    staticClass: "hover-pop rounded white",
    attrs: {
      "aspect-ratio": "16 / 9",
      "id": "38f35100-dd02-4682-baab-d6781771ac02",
      "alt": "Example corporate holiday card opening",
      "is-video": ""
    }
  }), _c('div', [_c('h4', {
    staticClass: "mb-3"
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiDomain)
    }
  }), _vm._v(" Corporate holiday cards")], 1), _c('div', [_vm._v(" The easiest way to create and send beautiful and memorable corporate holiday cards. Use our "), _c('router-link', {
    attrs: {
      "to": {
        name: 'bulk-email'
      }
    }
  }, [_vm._v("bulk email tool")]), _vm._v(" to send to your entire mailing list. ")], 1)]), _c('div', {
    staticClass: "relative hover-pop-group",
    staticStyle: {
      "aspect-ratio": "1"
    }
  }, [_c('div', {
    staticClass: "absolute rounded rn2 overflow-auto",
    staticStyle: {
      "width": "85%",
      "top": "0",
      "left": "0",
      "max-height": "100%"
    }
  }, [_c('web-media', {
    staticClass: "white",
    attrs: {
      "aspect-ratio": "16 / 9",
      "id": "ef377a9f-b5cc-4736-9cf2-ee5c9055cd36",
      "alt": "Example guest list"
    }
  })], 1), _c('outline-phone', {
    staticClass: "absolute has-alpha r5",
    staticStyle: {
      "top": "10%",
      "width": "45%",
      "right": "0"
    },
    attrs: {
      "vertical": ""
    }
  }, [_c('web-media', {
    attrs: {
      "aspect-ratio": "9 / 16",
      "id": "a23bb710-18e0-4d86-bcd9-484ed4d8192f",
      "alt": "Example holiday party RSVP on phone screen"
    }
  })], 1)], 1), _c('div', [_c('h4', {
    staticClass: "mb-3"
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiCalendar)
    }
  }), _vm._v(" Holiday party invitations")], 1), _c('div', [_vm._v(" Use all of Ellacard's design tools to create a memorable invitation for your holiday party. Track deliveries, collect RSVPs, and send updates / reminders. ")])]), _c('v-lazy', {
    staticStyle: {
      "aspect-ratio": "4 / 3"
    }
  }, [_c('router-link', {
    staticClass: "hover-pop-group giftcards-pile",
    attrs: {
      "to": {
        name: 'start-gift-cards'
      }
    }
  }, [_c('img', {
    staticClass: "rn5",
    staticStyle: {
      "top": "0",
      "left": "0"
    },
    attrs: {
      "loading": "lazy",
      "src": "https://gift.runa.io/static/product_assets/AMZ/AMZ-card.png",
      "alt": "Amazon gift card"
    }
  }), _c('img', {
    staticClass: "r3",
    staticStyle: {
      "top": "0",
      "right": "5%"
    },
    attrs: {
      "loading": "lazy",
      "src": "https://giftrocket-s3.imgix.net/Brands/US/Starbucks/Digital/starbucks_image_for_certificate.png",
      "alt": "Starbucks gift card"
    }
  }), _c('img', {
    staticClass: "rn3",
    staticStyle: {
      "top": "20%",
      "left": "5%"
    },
    attrs: {
      "loading": "lazy",
      "src": "https://gift.runa.io/static/product_assets/REI-US/REI-US-card.png",
      "alt": "REI gift card"
    }
  }), _c('img', {
    staticClass: "r3",
    staticStyle: {
      "bottom": "0",
      "left": "0"
    },
    attrs: {
      "loading": "lazy",
      "src": "https://giftrocket-s3.imgix.net/Brands/US/Target/Digital/Target.png",
      "alt": "Target gift card"
    }
  }), _c('img', {
    staticClass: "rn5",
    staticStyle: {
      "bottom": "0",
      "right": "5%"
    },
    attrs: {
      "loading": "lazy",
      "src": "https://gift.runa.io/static/product_assets/SEPHRA-US/SEPHRA-US-card.png",
      "alt": "Sephora gift card"
    }
  }), _c('img', {
    staticClass: "r1",
    staticStyle: {
      "top": "25%",
      "right": "0"
    },
    attrs: {
      "loading": "lazy",
      "src": "https://gift.runa.io/static/product_assets/UBER-US/UBER-US-card.png",
      "alt": "Uber gift card"
    }
  })])], 1), _c('div', [_c('h4', {
    staticClass: "mb-3"
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiWalletGiftcard)
    }
  }), _vm._v(" Gift cards")], 1), _c('div', [_vm._v(" Not going to see someone in person this year? Ellacard has "), _c('router-link', {
    attrs: {
      "to": {
        name: 'catalog-gift-cards'
      }
    }
  }, [_vm._v("gift cards from thousands of international merchants")]), _vm._v(", all wrapped up neatly in your customized card. ")], 1)])], 1), _c('div', {
    staticClass: "actions"
  }, [_c('v-btn', {
    staticClass: "btn-pop",
    attrs: {
      "x-large": "",
      "rounded": "",
      "dark": "",
      "color": "ec-blue",
      "to": {
        name: 'catalog-category',
        params: {
          category: 'holiday-cards'
        },
        hash: '#search'
      }
    }
  }, [_vm._v("Start a holiday card "), _c('v-icon', {
    staticClass: "mr-n1",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1), _c('v-btn', {
    staticClass: "mx-6 btn-pop",
    attrs: {
      "x-large": "",
      "rounded": "",
      "dark": "",
      "color": "pink",
      "to": {
        hash: '#demo-family'
      }
    }
  }, [_vm._v("Try demo…")])], 1), _c('div', {
    staticClass: "hidden-xs-only",
    staticStyle: {
      "height": "min(3vw, 64px)"
    }
  })]), _c('start-layer', {
    attrs: {
      "clip-waves-class": "holiday-red",
      "offset": .9
    },
    scopedSlots: _vm._u([{
      key: "overflow",
      fn: function () {
        return [_c('div', {
          staticClass: "relative mx-auto",
          staticStyle: {
            "max-width": "1185px",
            "z-index": "2"
          }
        }, [_c('card-shelf', {
          staticClass: "absolute",
          staticStyle: {
            "top": "calc(-32px - 3vw)",
            "pointer-events": "none"
          },
          attrs: {
            "examples": _vm.EXAMPLES.slice(0, 6)
          }
        })], 1)];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "mt-0",
    staticStyle: {
      "aspect-ratio": "5 / 7",
      "width": "min(calc(33% - 48px), 220px)"
    }
  }), _c('h2', [_vm._v("Examples")]), _c('div', {
    staticClass: "grid-alternate"
  }, [_vm._l(_vm.EXAMPLES, function (ex) {
    return [_c('v-lazy', {
      staticStyle: {
        "aspect-ratio": "4 / 3"
      }
    }, [_c('router-link', {
      staticClass: "d-block relative hover-pop rounded-xl",
      staticStyle: {
        "aspect-ratio": "4 / 3"
      },
      style: {
        'background-color': ex.color
      },
      attrs: {
        "to": {
          hash: ex.hash
        }
      }
    }, [_c('card-background', {
      staticClass: "overflow-hidden",
      staticStyle: {
        "border-radius": "24px"
      },
      attrs: {
        "src": ex.bg
      }
    }), _c('start-preview', {
      staticClass: "absolute",
      staticStyle: {
        "pointer-events": "none",
        "top": "10%",
        "left": "5%",
        "width": "90%"
      },
      attrs: {
        "alt": ex.title + ' example card',
        "pages": ex.pages
      }
    })], 1)], 1), _c('div', [_c('h4', {
      staticClass: "mb-3"
    }, [_vm._v(_vm._s(ex.title))]), _c('div', {
      staticClass: "mb-6"
    }, [_vm._v(_vm._s(ex.subtitle))]), _c('div', {
      staticClass: "ma-n2"
    }, [_c('v-btn', {
      staticClass: "btn-pop ma-2",
      attrs: {
        "rounded": "",
        "dark": "",
        "color": "ec-blue",
        "title": ex.title + ' demo',
        "to": {
          hash: ex.hash
        }
      }
    }, [_vm._v(" Try demo… ")]), _c('v-btn', {
      staticClass: "btn-pop ma-2",
      attrs: {
        "rounded": "",
        "dark": "",
        "color": "ec-blue",
        "title": ex.title + 's',
        "to": ex.to
      }
    }, [_vm._v("More like this "), _c('v-icon', {
      staticClass: "mr-n1",
      domProps: {
        "innerHTML": _vm._s(_vm.mdiChevronRight)
      }
    })], 1)], 1)])];
  })], 2), _c('div', {
    staticClass: "actions"
  }, [_c('v-btn', {
    staticClass: "btn-pop",
    attrs: {
      "x-large": "",
      "rounded": "",
      "dark": "",
      "color": "ec-blue",
      "to": {
        name: 'catalog-category',
        params: {
          category: 'holiday-cards'
        },
        hash: '#search'
      }
    }
  }, [_vm._v(" All holiday cards "), _c('v-icon', {
    staticClass: "mr-n1",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1), _c('v-btn', {
    staticClass: "btn-pop",
    attrs: {
      "x-large": "",
      "rounded": "",
      "dark": "",
      "color": "ec-blue",
      "to": {
        name: 'catalog-category',
        params: {
          category: 'holiday-party-invitations'
        },
        hash: '#search'
      }
    }
  }, [_vm._v(" All holiday invitations "), _c('v-icon', {
    staticClass: "mr-n1",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiChevronRight)
    }
  })], 1)], 1)]), _c('start-reviews', {
    attrs: {
      "tag": "HO"
    }
  }), _c('start-footer')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }